import React      from 'react';
import values     from '../../values';
import Context    from '../../context';
import Cookies    from 'js-cookie';
import constants  from '../../values/constants';
import Components from './Components';

import { useTranslation } from 'react-i18next';
import {
  BreadCrumb,
  Pagination,
  TableHeader,
  TableLoading,
  ResponsiveView, SubTabs,
} from '../../components';

import './index.scss';
import {ITopMenuItem} from "../../types/common.interface";
import {FILTER_USER_BY_FAVORIT_CITIES} from "../../values/subTabs";

type Props = { resultParent: any };

const ParentScreen: React.FC<Props> = (props: Props): React.ReactElement => {


  const { t } = useTranslation();
  const { status, data } = props.resultParent;
  const { requestParent, setRequestParent } = React.useContext(Context.ParentScreen);

  const [selectedCity, setSelectedCity] = React.useState<ITopMenuItem>(FILTER_USER_BY_FAVORIT_CITIES[0]);

  const writePermission: string | undefined = Cookies.get(constants.USER.WRITE_PERMISSION)?.toString();

  function onCityClick(tab: ITopMenuItem): void {
    setSelectedCity(tab);
    setRequestParent!({
      ...requestParent,
      filters: {
        ...requestParent?.filters,
        city: tab,
      },
    });
  }

  return (
    <ResponsiveView.Container id="driver-screen-container">
      <ResponsiveView.Row>
        <SubTabs tabs={FILTER_USER_BY_FAVORIT_CITIES} onClick={onCityClick} selected={selectedCity as ITopMenuItem} />
      </ResponsiveView.Row>
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </ResponsiveView.Column>
        <ResponsiveView.Column extraLarge={4} large={5} medium={7} className="search-and-filter-wrapper">
          {writePermission === "true" && <Components.Create />}
          <Components.Filter />
          <Components.Search />
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <div className="table-content-wrapper">
        <table>
          <TableHeader headers={values.tableHeaders.PARENT_HEADERS.map((item) => t(item))}/>
          {status === "loading" ? (<TableLoading />) : (<Components.Body data={data?.result?.docs} />)}
        </table>
      </div>
      {status === "success" &&
        data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestParent?.page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) => setRequestParent!({ ...requestParent, page })}
            />
          </div>
        )}
      <Components.Update />
      <Components.ShowInformation />
      <Components.RemoveIsArchive />
    </ResponsiveView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default ParentScreen;
